import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AlertMessageModule, ModalModule, SvgIconModule, TrAccordionModule } from '@toro/common/shared/components';
import { HubChipModule } from '@toro/common/shared/components/hub-chip/hub-chip.module';

import { RouterModule } from '@angular/router';
import { CustomerWalletCategoriesChartComponent } from './components/categories-chart/categories-chart.component';
import { CustomerWalletCategoryAccordionComponent } from './components/category-accordion/category-accordion.component';
import { CustomerWalletCategoryChipsComponent } from './components/category-chips/category-chips.component';
import { CustomerWalletPanelComponent } from './components/wallet-panel/wallet-panel.component';
import {
    ModalAccessFullWalletComponent
} from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/components/modal-full-wallet/modal-access-full-wallet.component';
import {
  ModalCriptoAccessComponent
} from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/components/modal-cripto-access/modal-cripto-access.component';
import {
  WalletFullAccessAlertComponent
} from './components/wallet-full-access-alert/wallet-full-access-alert.component';

const components = [
    CustomerWalletPanelComponent,
    CustomerWalletCategoryChipsComponent,
    CustomerWalletCategoriesChartComponent,
    CustomerWalletCategoryAccordionComponent,
    ModalAccessFullWalletComponent,
    ModalCriptoAccessComponent,
    WalletFullAccessAlertComponent,
];

@NgModule({
    declarations: components,
    exports: components,
    imports: [
        RouterModule,
        CommonModule,
        HubChipModule,
        SvgIconModule,
        TrAccordionModule,
        AlertMessageModule,
        ModalModule,
    ],
    providers: []
})
export class CustomerWalletModule {
}
